/**
 * 故障详情地图坐标兼容壳。
 * 设备上报 faultAddr 为 "lng,lat"（WGS84）；按底图厂商转坐标的逻辑已抽到 mapCoords.js，
 * 这里保留 parseFaultLngLat 仅为不破坏现有引用，内部转调 toMapLngLat。
 */
const { toMapLngLat } = require('./mapCoords')

/**
 * @param {string} faultAddr "lng,lat"
 * @param {'google'|'tianditu'} mapVendor
 * @returns {{lng:number,lat:number}|null}
 */
function parseFaultLngLat (faultAddr, mapVendor) {
  if (faultAddr == null || faultAddr === '') return null
  const parts = String(faultAddr).split(',')
  if (parts.length < 2) return null
  const lng = Number(parts[0])
  const lat = Number(parts[1])
  return toMapLngLat(lng, lat, mapVendor)
}

module.exports = {
  isInChina: require('./mapCoords').isInChina,
  parseFaultLngLat
}
